/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * MCP client filter option with usage in the selected time window
 */
export type ToolUsageClientFilterOption = {
  /**
   * Stable MCP client identity used by filters
   */
  clientKey: string;
  /**
   * User-facing label for the MCP client
   */
  clientLabel: string;
  /**
   * Number of tool usage events observed for the MCP client
   */
  eventCount: number;
};

/** @internal */
export const ToolUsageClientFilterOption$inboundSchema: z.ZodMiniType<
  ToolUsageClientFilterOption,
  unknown
> = z.pipe(
  z.object({
    client_key: z.string(),
    client_label: z.string(),
    event_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "client_key": "clientKey",
      "client_label": "clientLabel",
      "event_count": "eventCount",
    });
  }),
);

export function toolUsageClientFilterOptionFromJSON(
  jsonString: string,
): SafeParseResult<ToolUsageClientFilterOption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolUsageClientFilterOption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolUsageClientFilterOption' from JSON`,
  );
}
